import React, { Component } from "react";
import { Row, Col, Card, Button } from "antd";
import isEqual from "lodash/isEqual";
import findIndex from "lodash/findIndex";
import find from "lodash/find";
import { getGermanWordWithoutArticle } from "helpers";
import GameMap from "./GameMap";
import Editor from "./Editor";

class Level extends Component {
  state = {
    level: this.props.level
  };

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.level, this.state.level)) {
      this.setState({ level: nextProps.level });
    }
  }

  render() {
    const { allWords, language, title, onSave, wordsInGames } = this.props;
    const { level } = this.state;
    let valid = level.words.length > 0;
    let errorMessage = "";
    level.words.forEach((word, i1) => {
      if (word.wordID === "") {
        errorMessage = "Word ID is not saved or wrong";
        valid = false;
      }
      if (word.correctOrder.length < 2) valid = false;
      if (isEqual(level.words, this.props.level.words)) valid = false;

      let foundWord = "";

      if (find(allWords, { id: word.wordID })) {
        foundWord = find(allWords, { id: word.wordID })[language].toLowerCase();
        if (language === "de") {
          foundWord = getGermanWordWithoutArticle(foundWord);
        }
      }
      if (word.correctOrder.length !== foundWord.length) {
        valid = false;
        errorMessage = "All letters must be used";
      }
      word.correctOrder.forEach(item => {
        level.words.forEach(word2 => {
          if (word.wordID !== word2.wordID) {
            if (word2.correctOrder.indexOf(item) !== -1) {
              valid = false;
              errorMessage = "Index is used multiple times";
            }
          }
        });
      });
      if (wordsInGames.indexOf(word.wordID) !== -1) {
        if (findIndex(this.props.level.words, { wordID: word.wordID }) === -1) {
          valid = false;
          errorMessage = "Word has already used";
        }
      }
    });
    return (
      <Card
        title={title || `Level ${level.id}`}
        style={{ marginTop: 20 }}
        extra={
          valid ? (
            <Button
              type="danger"
              size="small"
              onClick={() => {
                onSave(level);
              }}
            >
              Save
            </Button>
          ) : (
            <span style={{ color: "red" }}>{errorMessage}</span>
          )
        }
      >
        <Row gutter={16}>
          <Col span={12}>
            <GameMap
              gameWords={level.words}
              allWords={allWords}
              language={language}
            />
          </Col>
          <Col span={12}>
            <Editor
              level={level}
              gameWords={level.words}
              allWords={allWords}
              language={language}
              onEdit={val => this.setState({ level: val })}
            />
          </Col>
        </Row>
      </Card>
    );
  }
}

export default Level;



// WEBPACK FOOTER //
// ./src/containers/Games/Level.js